import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import ErrorBoundary from "./utils/ErrorBoundary.jsx";
import * as Sentry from "@sentry/react";

const sentryKey = import.meta.env.VITE_SENTRY_KEY;
const sentryProject = import.meta.env.VITE_SENTRY_PROJECT;

Sentry.init({
  dsn: `https://${sentryKey}.ingest.us.sentry.io/${sentryProject}`,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {import.meta.env.VITE_ENV_NAME == "prod" ? (
      <ErrorBoundary fallback="There's some error">
        <App />
      </ErrorBoundary>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
